var _g, _g2, _g3, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6282_4725)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1387 2.57456C15.1912 1.69746 16.7973 2.33123 16.9672 3.69071C17.4909 7.88045 17.4909 12.1191 16.9672 16.3089C16.7973 17.6684 15.1912 18.3021 14.1387 17.425L9.798 13.8078C9.75307 13.7703 9.69643 13.7498 9.63795 13.7498H6C5.0335 13.7498 4.25 12.9663 4.25 11.9998V7.99976C4.25 7.03327 5.0335 6.24977 6 6.24977H9.63795C9.69643 6.24977 9.75307 6.22927 9.798 6.19183L14.1387 2.57456ZM15.4788 3.87677C15.456 3.69422 15.2403 3.60912 15.099 3.72689L10.7583 7.34416C10.4438 7.60624 10.0473 7.74977 9.63795 7.74977H6C5.86193 7.74977 5.75 7.8617 5.75 7.99976V11.9998C5.75 12.1379 5.86193 12.2498 6 12.2498H9.63795C10.0473 12.2498 10.4438 12.3933 10.7583 12.6554L15.099 16.2727C15.2403 16.3905 15.456 16.3054 15.4788 16.1228C15.9871 12.0566 15.9871 7.94295 15.4788 3.87677Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6282_4725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9083 3.94634C22.3015 3.81628 22.7258 4.02964 22.8558 4.4229C23.4363 6.17787 23.7501 8.05336 23.7501 10.0006C23.7501 11.9479 23.4363 13.8233 22.8558 15.5783C22.7258 15.9716 22.3015 16.1849 21.9083 16.0549C21.515 15.9248 21.3016 15.5006 21.4317 15.1073C21.9625 13.5024 22.2501 11.7858 22.2501 10.0006C22.2501 8.21536 21.9625 6.49884 21.4317 4.89392C21.3016 4.50065 21.515 4.07641 21.9083 3.94634Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6282_4725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0323 5.94785C19.8894 5.55905 19.4584 5.35967 19.0696 5.50252C18.6808 5.64538 18.4815 6.07637 18.6243 6.46517C19.0288 7.56609 19.25 8.75644 19.25 10.0001C19.25 11.0317 19.0978 12.0265 18.8152 12.9638C18.7995 13.016 18.7833 13.0681 18.7668 13.1199C18.7222 13.2596 18.6747 13.3981 18.6243 13.5351C18.4815 13.9239 18.6808 14.3549 19.0696 14.4978C19.4584 14.6406 19.8894 14.4412 20.0323 14.0524C20.0901 13.8952 20.1446 13.7363 20.1958 13.576C20.2148 13.5164 20.2333 13.4567 20.2514 13.3968C20.5758 12.3205 20.75 11.18 20.75 10.0001C20.75 8.57734 20.4968 7.21202 20.0323 5.94785Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.1992,
    y: 2.05762,
    width: 1.93092,
    height: 25,
    rx: 0.96546,
    transform: "rotate(53.6174 22.1992 2.05762)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6282_4725",
    x: 0.666901,
    y: 0.379349,
    width: 20.2765,
    height: 22.8239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.79155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79155
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6282_4725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6282_4725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6282_4725",
    x: 17.8105,
    y: 2.11665,
    width: 9.52264,
    height: 19.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.79155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79155
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6282_4725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6282_4725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6282_4725",
    x: 14.995,
    y: 3.66475,
    width: 9.33807,
    height: 16.2538,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.79155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79155
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6282_4725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6282_4725",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/Mute.5ed1d9f1616621ac859f09bd6879a562.svg";
export { ForwardRef as ReactComponent };